import { render, staticRenderFns } from "./TicketActivity.vue?vue&type=template&id=5f2d2dc0"
import script from "./TicketActivity.vue?vue&type=script&lang=js"
export * from "./TicketActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports